import React, { useContext, useState } from "react";
import { Loading } from "../../../../../../../../components/ui/Loading";
import { AnimatedModal } from "../../../../../../../../components/ui/Modal";
import { AuthContext } from "../../../../../../../../contexts/auth";
import { useAuthenticatedApi } from "../../../../../../../../hooks/useApi";

interface DeleteAccountProps {
  toggleModal: any;
}

const DeleteAccount: React.FC<DeleteAccountProps> = ({ toggleModal }) => {
  const { logout } = useContext(AuthContext);
  const [isDeleted, setDeleted] = useState<boolean>(false);
  const [isLoadingDelete, setLoadingDelete] = useState(false);
  const handleLogout = () => {
    logout();
    window.location.href = "/";
  };

  const profileDelete = useAuthenticatedApi("PROFILE_SUPPORT_DELETE");

  const requestDeleteAccount = () => {
    if (profileDelete) {
      profileDelete
        .post("/")
        .then((res) => {
          if (res.status === 200 || res.status === 201) {
            console.log("zo", res);
          }
        })
        .catch((e) => console.log(e));
    }
  };

  const onDelete = () => {
    requestDeleteAccount();
    setLoadingDelete(true);
    setTimeout(() => {
      setLoadingDelete(false);
      setDeleted(true);
      setTimeout(() => {
        handleLogout();
      }, 10000);
    }, 5000);
  };

  return (
    <>
      <AnimatedModal
        visible={toggleModal}
        className="relative mt-4 overflow-y-auto bg-white border rounded-lg w-96"
      >
        {isLoadingDelete ? (
          <div className="h-40 mx-4 my-8 text-center ">
            <h4 className="mt-4 text-lg font-medium text-primary">
              Deleting your account..
            </h4>
            <div className="flex flex-col items-center justify-center mt-8">
              <Loading className="p-4 rounded-full shadow-lg w-18 h-18" />
              <span className="mt-4 font-medium text-text">
                Follow your{" "}
                <span role="img" aria-label="heart">
                  ❤️
                </span>
              </span>
            </div>
          </div>
        ) : isDeleted ? (
          <div className="mx-4 my-8 text-center ">
            <h4 className="mt-4 text-lg font-medium text-primary">
              Account Deactivated
            </h4>

            <p className="mt-2 text-md text-text">
              Your account will be completely deleted in the next 24 hours. You
              can reactivate your account during this time by re-logging in.
            </p>
          </div>
        ) : (
          <>
            <div className="mx-4 my-8 text-center">
              <h4 className="mt-4 text-lg font-medium text-primary">
                You're about to delete your account
              </h4>

              <p className="mt-2 text-md text-text">
                Are you sure you want to do this? You'll lose all your data and
                bookings.
              </p>
            </div>
            <div className="grid grid-cols-2 grid-rows-1">
              <button
                className="px-4 py-2 text-sm font-medium text-center text-blue-600 border-t border-r border-gray-200 hover:bg-blue-100 focus:outline-none"
                onClick={toggleModal}
              >
                <span role="img" aria-label="No Emoji" className="mr-4">
                  😌
                </span>
                No
              </button>
              <button
                className="px-4 py-2 text-sm font-medium text-center text-red-600 border-t border-gray-200 hover:bg-red-100 focus:outline-none"
                onClick={onDelete}
              >
                <span role="img" aria-label="Yes Emoji" className="mr-4">
                  🥺
                </span>
                Yes
              </button>
            </div>
          </>
        )}
      </AnimatedModal>
    </>
  );
};

export default DeleteAccount;
